<template>
  <button type="button" class="btn btn-outline-dark btn-sm btn-fl-filter-active" @click="$emit('click')">
    <b>{{filter_item.name}}:</b>
    {{ filter_item.value }}
    <i class="far fa-times-circle ml-1"></i>
  </button>
</template>

<script>

export default {
  name: "selected",
  props: ['filter_item']
}
</script>
